<!-- =========================================================================================
  File Name: FullPage.vue
  Description: Full page layout
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div class="layout--full-page">
      <vs-row class="header" vs-type="flex" vs-align="center">
          <vs-col vs-w="6">
              <img :src="require('@/assets/images/logo/timeless.png')" alt="" width="90">
          </vs-col>
          <vs-col vs-w="6" vs-type="flex" vs-justify="flex-end" vs-align="center">
              <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
                  <vs-row vs-type="flex" vs-jusitfy="center">
                      <vs-col vs-w="12">
                          <span class="dropLang">{{lang == 'zh' ? '繁體中文' : (lang == 'zh_cn' ? '简体中文' : 'English')}}</span>
                          <vs-icon class="" icon="expand_more" color="#DEB880"></vs-icon>
                      </vs-col>
                  </vs-row>
                  <vs-dropdown-menu>
                      <ul style="min-width: 9rem">
                          <li v-for="item in langOpt" v-if="item.value != lang"
                              class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
                              @click="changeLang(item.value)">
                              <span class="ml-2">{{item.text}}</span></li>
                      </ul>
                  </vs-dropdown-menu>
              </vs-dropdown>
          </vs-col>
      </vs-row>
      <router-view></router-view>
      <div class="footer">
          <!-- <h5 :class="isMobile() ? 'partnerMob' :'partner'">{{$t('message.partnerOf')}}</h5> -->
          <vs-row vs-type="flex" vs-align="center" style="background: white">
              <vs-col vs-w="12">
                <div class="text" style="padding: 5px 25px; margin-top: 30px; margin-bottom: 30px;">
                    <strong>網絡安全提醒:</strong> <br>
                    <ul>
                        <li>為確保您的賬戶安全 •請不要點按任何電子郵件、未經授權或未知的第三方網站嵌入的超連結登入天時信託網上系統。</li>
                        <li>天時信託不會以電郵要求客戶輸入機密的戶口資料．例如用戶名稱、密碼或其他有關任何銀行戶口及信用卡資料等</li>
                        <li>天時信託並沒有授權任何網上金融整合工具連接本系統或獲取本客戶的資料 。我們提醒客戶，切勿向未經授權的第三方披露網上系統的登入名稱和密碼。</li>
                        <li>如有需要協助，請電郵至：<strong><a href="mailto:cs@timeless-trust.com">cs@timeless-trust.com</a></strong> •我們的客戶服務專員將會盡快和您聯繫。</li>
                    </ul> <br>
                    <strong>网络安全提醒：</strong> <br>
                    <ul>
                        <li>为确保您的账户安全 •请不要点按任何电子邮件、未经授权或未知的第三方网站嵌入的超连结登入天时信托网上系统。</li>
                        <li>天时信托不会以电邮要求客户输入机密的户口资料，例如用户名称、密码或其他有关任何银行户口及信用卡资料等。</li>
                        <li>天时信托并没有授权任何网上金融整合工具连接本系统或获取本客户的资料。我们提醒客户，切勿向末经授权的第三方披露网上条统的登入名称和密码</li>
                        <li>如有需要协助，请电邮至：<strong><a href="mailto:cs@timeless-trust.com">cs@timeless-trust.com</a></strong> •我们的客户服务专员将会尽快和您联系。</li>
                    </ul> <br>
                    <strong>Reminders：</strong> <br>
                    <ul>
                        <li>To protect yourself, do not login to Timeless Trust through hyperlinks embedded in emails, unauthorized or third party websites.</li>
                        <li>Timeless Trust will never ask you for your sensitive account information, e.g. username, password and other confidential account or credit card information by email.</li>
                        <li>Timeless Trust has not authorized any third party aggregator applications to access our systems nor customer information. You are reminded not to disclose your usernames and passwords to third parties</li>
                        <li>Should you have any enquiries, please email to <strong><a href="mailto:cs@timeless-trust.com">cs@timeless-trust.com</a></strong>, our customer service officer shall contact you as soon as possible</li>
                    </ul>
                </div>
              </vs-col>
          </vs-row>
      </div>
  </div>
</template>
<script>
export default {
    data() {
        return{
            langOpt: [
                {
                    text: 'English',
                    value: 'en'
                },
                {
                    text: '繁體中文',
                    value: 'zh'
                },
                {
                    text: '简体中文',
                    value: 'zh_cn'
                }
            ],
            lang: '',
        }
    },
    created() {
        this.lang = this.$cookies.get('lang');
    },
    methods: {
        changeLang(lang) {
            this.$cookies.set('lang', lang)
            location.reload()
        },
    }
}
</script>

<style lang="scss" scoped>
.partner {
    position: relative;
    top: 20%;
    left: 3%;
}

.text{
   width: 1170px; 
   margin: 0 auto;
}

.partnerMob {
    font-size: 12px;
    position: relative;
    top: 5%;
    left: 3%;
}

.header {
    width: 100%;
    height: 80px;
    background: rgb(247, 247, 247);
    padding: 5px 25px;
}
.footer {
    height: 18vh;
    background: white;
}

.footer .vs-col {
    padding: 5px;
}

li{
    list-style: inside !important;
}

.dropLang {
    color: #DEB880;
    margin-right: 10px
}

@media (max-width: 768px) {
    .text{
        width: 100%;
    }
}

</style>
